import { format } from 'date-fns';

// eslint-disable-next-line import/prefer-default-export
export const formatIso8601DateTime = date =>
  format(date, "yyyy-MM-dd'T'HH:mm:ssXXX");

/**
 * @deprecated
 * use {@link formatLocalDateTime} from now on
 */
export const formatDateTime = dateTime =>
  format(dateTime, 'yyyy-MM-dd HH:mm:ss');

export const formatLocalDateTime = dateTime =>
  format(dateTime, 'yyyy-MM-dd HH:mm:ss');

export const formatLocalDate = dateTime => format(dateTime, 'yyyy-MM-dd');
